import { formatDateParam, makeRequest } from "../lib/makeRequest";

export const package_overall_v4 = (data) => {
  const params = data.isRange
    ? {
        from: formatDateParam(data.dates.from),
        to: formatDateParam(data.dates.to),
      }
    : { coveredDate: formatDateParam(data.dates.from) };

  return makeRequest("/package-summaries/overall", params);
};

export const package_cluster_v4 = (data) => {
  const params = data.isRange
    ? {
        from: formatDateParam(data.dates.from),
        to: formatDateParam(data.dates.to),
      }
    : { coveredDate: formatDateParam(data.dates.from) };

  return makeRequest(`/package-summaries/cluster/${data.clusterId}`, params);
};

export const package_area_v4 = (data) => {
  const params = data.isRange
    ? {
        from: formatDateParam(data.dates.from),
        to: formatDateParam(data.dates.to),
      }
    : { coveredDate: formatDateParam(data.dates.from) };
  return makeRequest(`/package-summaries/area/${data.areaId}`, params);
};

export const package_branch_v4 = (data) => {
  const urlParams = new URLSearchParams();

  if (data.isRange) {
    urlParams.append("from", formatDateParam(data.dates.from));
    urlParams.append("to", formatDateParam(data.dates.to));
  } else {
    urlParams.append("coveredDate", formatDateParam(data.dates.from));
  }

  return makeRequest(
    `/package-summaries/branches?${urlParams.toString()}`,
    data.branch_codes,
    "post"
  );
};
